import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "layout-content-wrapper" }
const _hoisted_2 = { class: "layout-main" }
const _hoisted_3 = { class: "layout-content" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Telegram", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Skype", -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "layout-footer" }
const _hoisted_13 = { class: "grid" }
const _hoisted_14 = { class: "col-12 md:col-6" }
const _hoisted_15 = { class: "footer-bottom flex-column align-items-start sm:flex-row sm:align-items-center" }
const _hoisted_16 = { class: "mb-2 sm:mb-0" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "col-12 text-xs" }
const _hoisted_19 = {
  key: 0,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Analytics = _resolveComponent("Analytics")!
  const _component_Tawk = _resolveComponent("Tawk")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["layout-wrapper layout-sidebar layout-static", _ctx.layoutWrapperClass])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_TopBar, { onOnMenuButtonClick: _ctx.toggleMenu }, null, 8, ["onOnMenuButtonClick"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.user.ui_advertiser && _ctx.user.ui_contact_notification)
              ? (_openBlock(), _createBlock(_component_PrimeVueMessage, {
                  key: 0,
                  severity: "warn",
                  closable: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('ui_contact_notification_message')), 1),
                      (_ctx.user.ui_contact_notification_via)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.user.ui_contact_notification_via), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.user.manager)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.user.manager.telegram)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _hoisted_7,
                                        _createElementVNode("a", {
                                          href: `https://t.me/${_ctx.user.manager.telegram}`,
                                          target: "_blank"
                                        }, _toDisplayString(_ctx.user.manager.telegram), 9, _hoisted_8)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.user.manager.skype)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _hoisted_10,
                                        _createElementVNode("a", {
                                          href: `skype:${_ctx.user.manager.skype}?chat`,
                                          target: "_blank"
                                        }, _toDisplayString(_ctx.user.manager.skype), 9, _hoisted_11)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.project.name), 1),
                  (!_ctx.project.white_label)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_17, "⚙️ " + _toDisplayString(_ctx.$t('powered_by')) + " AdBison Platform", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('server_time')) + ": " + _toDisplayString(_ctx.project.server_time) + " (UTC +3:00)", 1),
              (!_ctx.user.isAffiliate() || _ctx.user.ui_advertiser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      class: "text-indigo-400",
                      to: "/advertising-and-refund-policy"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('advertising_and_refund_policy')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", {
            class: "layout-mask modal-in",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLayoutMaskClick && _ctx.onLayoutMaskClick(...args)))
          })
        ])
      ])
    ], 2),
    _createVNode(_component_Analytics, { project: _ctx.project }, null, 8, ["project"]),
    (_ctx.project.tawk_to && _ctx.user.isAffiliate())
      ? (_openBlock(), _createBlock(_component_Tawk, {
          key: 0,
          project: _ctx.project,
          user: _ctx.user
        }, null, 8, ["project", "user"]))
      : _createCommentVNode("", true)
  ], 64))
}